import { PaginatedResponse, useApi } from '@/api';
import { Carousel, LinkButton, ProgressBar } from '@/components';
import {
  Card,
  CurrencyValue,
  Flex,
  FlexProps,
  Heading,
  KpiSkeleton,
  Text,
  WalletAddress
} from '@blockanalitica/ui';
import styled, { css } from 'styled-components';

type StakingData = {
  balance: string;
  wallet_address: string;
};

const KpiTitle = styled(Flex)<FlexProps>`
  ${(props) => css`
    color: ${props.theme.colors.muted};
    font-size: ${props.theme.sizes['-1']};
  `}
`;

export default function TopStakedWallets() {
  const [data, error] = useApi<
    PaginatedResponse<StakingData[]> & { total_staked: string }
  >({
    url: '/sparkstar/staking/holders/',
    queryParams: {
      p: 1,
      p_size: 5
    }
  });

  if (error) {
    throw error;
  }
  if (!data) {
    return (
      <Carousel>
        <KpiSkeleton />
        <KpiSkeleton />
        <KpiSkeleton />
      </Carousel>
    );
  }

  const totalAmount = Number(data['total_staked']);

  return (
    <Flex flexDirection="column" gap="xs">
      <Flex justifyContent="space-between" alignItems="center">
        <Heading size="2">Top Stakers</Heading>
        <LinkButton to="staking" variant="whiteAndUgly" fontSize="-1">
          View all
        </LinkButton>
      </Flex>

      <Carousel>
        {data.results.map((row) => (
          <Card
            key={row.wallet_address}
            gap="s"
            justifyContent="space-between"
            flexDirection="column">
            <Flex flexDirection="column" gap="s">
              <WalletAddress address={row.wallet_address} />

              <Flex flexDirection="column" flex="1" gap="3xs">
                <KpiTitle>Total Staked</KpiTitle>
                <CurrencyValue
                  value={row.balance}
                  fontSize="3"
                  variant="dynamic"
                  options={{
                    currency: {
                      name: 'SPK',
                      address: '0xc20059e0317de91738d13af027dfc4a50781b066'
                    }
                  }}
                />
              </Flex>
            </Flex>
            <ProgressBar
              color="#FFFFFF"
              percent={Number(row.balance) / totalAmount}
              text={
                <Text color="muted" size="2">
                  {'% of total farmed'}
                </Text>
              }
              height="-4"
            />
          </Card>
        ))}
      </Carousel>
    </Flex>
  );
}
